import React, {useImperativeHandle} from "react";
import {runtime} from "@codeArt/common";
import {type} from "@codeArt/utils/common";
import {Divider} from "@material-ui/core";
import {GoCellLink, Link} from "@codeArt/components/button/link";
import DataTable from "./dataTable/index";
import {View} from "@codeArt/components/html/View";
import {useDispatch} from "react-redux";
import {getColumnField} from "./dataTable/util";

function mapAlign(align){
  switch (align) {
    case "left":
      return "start";
    case "right":
      return "end";
    default:
  }
  return align || "start";
}

const DataGrid = React.forwardRef((props, ref) => {
  const dispatch = useDispatch();

  let core = null;

  const selectMode = type => {
    return core.selectMode(type);
  };

  const getData = () => {
    return core.getData();
  };

  const get = () => {
    return core.get();
  };

  const set = items => {
    return core.set(items);
  };

  const reverseSet = items => {
    return core.reverseSet(items);
  };

  const reverseGet = items => {
    return core.reverseGet();
  };

  const reset = items => {
    return core.reset();
  };

  const load = () => {
    core.load();
  };

  const reload = arg => {
    core.reload(arg);
  };

  useImperativeHandle(ref, () => ({
    selectMode,
    getData,
    get,
    set,
    reverseSet,
    reverseGet,
    reset,
    load,
    reload
  }));

  const renderColumn = (data, column, i, go) => {
    let {mobile, align, onClick} = column;
    if (!mobile) return;
    let {width, height, className, ellipsis} = mobile;
    align = mobile.align || align;
    onClick = mobile.onClick || onClick || go;
    width = width || "auto";
    ellipsis = ellipsis === false ? "" : "c-ellipsis";
    if (width === "full") width = "100%";
    align = mapAlign(align);
    let field = getColumnField(column);

    let render = column.component || mobile.component;

    return (
      <div
        className={`d-flex justify-content-${align} align-items-center ${onClick
          ? "c-pointer"
          : ""} 
          c-text-s2 ${ellipsis} my-3 ${className || ""}`}
        key={i}
        onClick={
          onClick ? (
            () => {
              onClick(data);
            }
          ) : null
        }
        style={{width, height}}
      >
        {render ? render(data) : data[field]}
      </div>
    );
  };

  const defaultRenderItem = (data, columns, noLine, go) => {
    //从列配置中提取可在移动端显示的数据
    return [
      <div
        key={0}
        className="d-flex flex-row justify-content-start align-items-center w-100"
      >
        {columns.map((column, i) => {
          return this.renderColumn(data, column, i, go);
        })}
        {go ? (
          this.renderColumn(
            data,
            {
              mobile: {width: "auto"},
              align: "center",
              component: row => {
                return (
                  <GoCellLink
                    className="h-100"
                    color="primary"
                    onClick={e => {
                      e.stopPropagation();
                      go(row);
                    }}
                  />
                );
              }
            },
            columns.length,
            go
          )
        ) : null}
      </div>,
      noLine ? null : <Divider key={1} />
    ];
  };

  // const wrapperRenderItem = (data, renderItem, noLine) => {
  //   //从列配置中提取可在移动端显示的数据
  //   return (
  //     <React.Fragment>
  //       <div
  //         key={0}
  //         className="d-flex flex-row justify-content-start align-items-center w-100"
  //       >
  //         {renderItem(data)}
  //       </div>
  //       noLine ? null : <Divider key={1} />
  //     </React.Fragment>
  //   );
  // };

  const table = () => {
    let p = {...props};
    if (!p.columns && p.renderItem) {
      //如果仅指定了renderItem，那么需要做一下转换
      let renderItem = p.renderItem;
      p.columns = [
        {
          disablePadding: true,
          component: (data, index) => {
            return renderItem(data, index);
          }
        }
      ];

      delete p.renderItem;
    }

    return (
      <DataTable
        ref={r => {
          core = r;
        }}
        {...p}
        dispatch={dispatch}
      />
    );
  };

  const repeater = () => {
    let p = {...props, headers: false};
    return (
      <DataTable
        ref={r => {
          core = r;
        }}
        {...p}
        dispatch={dispatch}
      />
    );
  };

  return props.repeater ? repeater() : table();
});

DataGrid.defaultProps = {
  className: "",
  pageSize: 25,
  emptyText: "暂无数据",
  page: true,
  scrollable: true,
  mobile: {ellipsis: true}
};

DataGrid.modalClassName = runtime.mobile ? "py-2" : "py-4";

export default DataGrid;

export class DataCell extends React.Component {

  constructor(props) {
    super(props);
  }


  render() {
    let { children, className } = this.props;
    let p = { ...this.props };
    delete p.children; delete p.className;


    return (
      <div className={`row no-gutters w-100 ${className}`} {...p}>
        <div className="col-12">
          {children}
        </div>
      </div>
    )
  }

}

DataCell.defaultProps = {
  className: ''
}
